// https://tools.ietf.org/html/rfc6455#section-7.4.1
export const WS_CLOSE_CODE_NORMAL = 1000;
export const WS_CLOSE_CODE_GOING_AWAY = 1001;
export const WS_CLOSE_UNSUPPORTED_DATA = 1003;
export const WS_CLOSE_CODE_ABNORMAL_CLOSE = 1006;

export const MESSAGE_TYPE_MEDIA = 'media';
export const MESSAGE_TYPE_LOOM_EVENT = 'loom_event';
